document.addEventListener("alpine:init", () => {
    Alpine.data("newsletterContactForm", () => ({
        visible: false,
        showForm: false,
        topicButtons: {},
        topicCheckboxes: {},
        topicsChosen: [],
        sendingContainer: null,
        successContainer: null,
        selectFields: null,
        init() {
            this.topicButtons = this.$el.querySelectorAll(".topic__button");
            this.topicCheckboxes = this.$el.querySelectorAll(
                "input[name='newsletter-topics[]']"
            );

            // Form sending and success

            this.sendingContainer = this.$el.querySelector(
                ".Newsletter__Contact__Form__sending"
            );
            this.successContainer = this.$el.querySelector(
                ".Newsletter__Contact__Form__success"
            );

            this.$el.querySelectorAll(".wpcf7-submit").forEach((button) => {
                button.addEventListener("click", () => {
                    this.sendingContainer.classList.remove("hidden");
                    this.sendingContainer.classList.add("flex");
                });
            });

            this.$el.querySelector(".wpcf7").addEventListener(
                "wpcf7invalid",
                (e) => {
                    this.sendingContainer.classList.add("hidden");
                    this.sendingContainer.classList.remove("flex");
                },
                false
            );

            this.$el.querySelector(".wpcf7").addEventListener(
                "wpcf7mailsent",
                (e) => {
                    this.sendingContainer.classList.add("hidden");
                    this.sendingContainer.classList.remove("flex");
                    this.successContainer.classList.add("flex");
                    this.successContainer.classList.remove("hidden");
                    pegasus.scroll(this.successContainer, 0, "scrollTo");
                },
                false
            );

            // Select fields

            this.selectfields = this.$el.querySelectorAll("select");
            pegasus.selectField(this.selectfields, {
                openOnHover: false,
                itemsToShow: 5,
                firstItemDisabled: true,
                classNames: {
                    outerWrapper: "",
                    selector:
                        "Form__Selector -no-cancel w-full cursor-pointer flex text-left relative focus:outline-none py-2 pr-1",
                    selectorOpen: "-open",
                    selectionList:
                        "Form__Selector-list w-full rounded-b-md -open",
                    listItem:
                        "select-none relative transition duration-300 py-4 px-6",
                    listItemFocus: "",
                },
            });
        },
        toggleChoice(value) {
            if (typeof this.topicsChosen === "undefined") {
                this.topicsChosen = value;
                return;
            }

            if (this.topicsChosen.length) {
                if (this.topicsChosen.includes(value)) {
                    this.topicsChosen = this.removeChoice(value);
                } else {
                    this.topicsChosen += "," + value;
                }
            } else {
                this.topicsChosen = value;
            }

            // Checkboxes

            let currentCheckbox = document.querySelector(
                "input[type='checkbox'][value='" + value + "']"
            );

            currentCheckbox.click(); // click needed for CF7 validation

            //currentCheckbox.checked = !currentCheckbox.checked;
        },
        removeChoice(value) {
            const choiceValue = this.topicsChosen;
            const choiceValueArray = choiceValue.split(",");

            for (let i = 0; i < choiceValueArray.length; i++) {
                if (choiceValueArray[i] === value) {
                    choiceValueArray.splice(i, 1);
                }
            }

            return choiceValueArray.toString();
        },
    }));
});
